import { Link, Route, Routes, useLocation } from 'react-router-dom';
import T from '@wojtekmaj/react-t';

import { FormWrapper, Main, PageWrapper } from './index.styles';

import Footer from '../../footer';
import Header from '../../header';
import Heading from '../../heading';
import LoginEmail from './email';
import LoginMain from './main';

export default function LoginPage() {
  const location = useLocation();

  return (
    <PageWrapper>
      <Header />
      <FormWrapper>
        <Main>
          <Heading align="center">Login</Heading>
          <Routes>
            <Route element={<LoginMain />} path="" />
            <Route element={<LoginEmail />} path="email" />
          </Routes>
          <p>
            <T>Don’t have an account yet?</T>{' '}
            <Link state={location.state} to="/register">
              <T>Register</T>
            </Link>
            .
          </p>
        </Main>
      </FormWrapper>
      <Footer />
    </PageWrapper>
  );
}
